import { render, staticRenderFns } from "./SidenavBlock.vue?vue&type=template&id=034d06a8"
import script from "./SidenavBlock.vue?vue&type=script&lang=js"
export * from "./SidenavBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports